module.exports = __webpack_public_path__ + "static/media/contract.9207370b.svg";